<div class="content margin-auto" style="padding-top: 24px;" role="main">
  <div #canvas style="margin-bottom: 14px;"></div>

    <mat-form-field appearance="outline">
        <mat-label>File Extension</mat-label>
        <mat-select [value]="extension" (selectionChange)="onMatChange($event)">
            <mat-option value="png">PNG</mat-option>
            <mat-option value="jpeg">JPEG</mat-option>
            <mat-option value="svg">SVG</mat-option>
            <mat-option value="webp">WEBP</mat-option>
        </mat-select>
    </mat-form-field>
    
    <button mat-raised-button color="primary" (click)="download()" style="margin-left: 8px;">
        <mat-icon>file_download</mat-icon>
        Download
    </button>
  
</div>